<div class="page-container">
  <app-header></app-header>
  <div class="base">
    <router-outlet></router-outlet>
  </div>
  <div class="footer-container">
    <app-footer></app-footer>
  </div>
</div>